import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
export const PF = `${API}/api/personal-finance`;

export const fmtEur = (v) => `${(v ?? 0).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€`;

export const currentMonth = () => new Date().toISOString().slice(0, 7);

export const AMBITOS = ['Profissional', 'Pessoal', 'Meninas', 'Casa', 'Poupança', 'Neutro'];
export const SUBCATS_MENINAS = ['Saúde', 'Escola', 'Atividades', 'Roupa', 'Subscrições', 'Babysitter', 'Outros'];
export const AMBITO_POR_CLASSIFICAR = 'Por classificar';

export default axios;
